import { Link } from 'react-router-dom'

export interface LinkButtonProps {
  to: string
  children?: React.ReactNode
  onClick?: React.MouseEventHandler
}

export function LinkButton(props: LinkButtonProps) {
  return (
    <Link to={props.to} className="k-button k-button-solid-primary k-rounded-md" style={{ display: 'flex' }} onClick={props.onClick}>
      <div style={{ verticalAlign: 'middle' }}>
        {props.children}
      </div>
    </Link>
  )
}
